module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAdd
    }
  }, [_vm._v("Add Category")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showUserRate
    }
  }, [_vm._v("User Rate")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.boxSizes,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sizeDefined",
      "label": "Full Label"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sizeLabel",
      "label": "Short Label"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundBaseFee",
      "label": "Inbound Base Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundRate",
      "label": "Inbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundBaseFee",
      "label": "Outbound Base Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundRate",
      "label": "Outbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageBaseFee",
      "label": "Storage Base Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageBaseFeeOver",
      "label": "Storage Base Fee > Years"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isPrintBarCode",
      "label": "Print Bar Code",
      "formatter": _vm.formatPrintStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Category",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addCategory",
    attrs: {
      "model": _vm.addCategory,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Short Label",
      "prop": "sizeLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addCategory.sizeLabel),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "sizeLabel", $$v)
      },
      expression: "addCategory.sizeLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Full Label",
      "prop": "sizeDefined"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addCategory.sizeDefined),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "sizeDefined", $$v)
      },
      expression: "addCategory.sizeDefined"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Base Fee",
      "prop": "inboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.inboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "inboundBaseFee", $$v)
      },
      expression: "addCategory.inboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Rate",
      "prop": "inboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.inboundRate),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "inboundRate", $$v)
      },
      expression: "addCategory.inboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Base Fee",
      "prop": "outboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.outboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "outboundBaseFee", $$v)
      },
      expression: "addCategory.outboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Rate",
      "prop": "outboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.outboundRate),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "outboundRate", $$v)
      },
      expression: "addCategory.outboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee",
      "prop": "storageBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.storageBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "storageBaseFee", $$v)
      },
      expression: "addCategory.storageBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee >Years",
      "prop": "storageBaseFeeOver"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.addCategory.storageBaseFeeOver),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "storageBaseFeeOver", $$v)
      },
      expression: "addCategory.storageBaseFeeOver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is Print Bar Code",
      "prop": "isPrintBarCode"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select Print Bar Code",
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.addCategory.isPrintBarCode),
      callback: function($$v) {
        _vm.$set(_vm.addCategory, "isPrintBarCode", $$v)
      },
      expression: "addCategory.isPrintBarCode"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "Printed"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 0,
      "label": "Not Print"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddBoxSize.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Category",
      "width": "80%",
      "visible": _vm.editVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editCategory",
    attrs: {
      "model": _vm.editCategory,
      "label-width": "220px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Short Label",
      "prop": "sizeLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editCategory.sizeLabel),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "sizeLabel", $$v)
      },
      expression: "editCategory.sizeLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Full Label",
      "prop": "sizeDefined"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editCategory.sizeDefined),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "sizeDefined", $$v)
      },
      expression: "editCategory.sizeDefined"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Base Fee",
      "prop": "inboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.inboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "inboundBaseFee", $$v)
      },
      expression: "editCategory.inboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Rate",
      "prop": "inboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.inboundRate),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "inboundRate", $$v)
      },
      expression: "editCategory.inboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Base Fee",
      "prop": "outboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.outboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "outboundBaseFee", $$v)
      },
      expression: "editCategory.outboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Rate",
      "prop": "outboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.outboundRate),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "outboundRate", $$v)
      },
      expression: "editCategory.outboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee",
      "prop": "storageBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.storageBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "storageBaseFee", $$v)
      },
      expression: "editCategory.storageBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee >Years",
      "prop": "storageBaseFeeOver"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.editCategory.storageBaseFeeOver),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "storageBaseFeeOver", $$v)
      },
      expression: "editCategory.storageBaseFeeOver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is Print Bar Code",
      "prop": "isPrintBarCode"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select Print Bar Code",
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.editCategory.isPrintBarCode),
      callback: function($$v) {
        _vm.$set(_vm.editCategory, "isPrintBarCode", $$v)
      },
      expression: "editCategory.isPrintBarCode"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "Printed"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 0,
      "label": "Not Print"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "User Rate List",
      "width": "80%",
      "visible": _vm.userRateVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.userRateVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondLoading),
      expression: "secondLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.userRates,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Doctor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hasSingleSeted",
      "label": "Has bean set"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.hasSingleSeted ? "Already Set" : "Not Set") + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showCategoryEdit(scope.row.doctorNo)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.userRateVisible = false;
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Custom Category Set",
      "width": "80%",
      "visible": _vm.customCategoryVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customCategoryVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdLoading),
      expression: "thirdLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.customCategoryConfigs,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sizeDefined",
      "label": "Full Label"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.sizeDefined) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sizeLabel",
      "label": "Short Label"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.sizeLabel) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundBaseFee",
      "label": "Inbound Base Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.inboundBaseFee) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundRate",
      "label": "Inbound Rate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.inboundRate) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundBaseFee",
      "label": "Outbound Base Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.outboundBaseFee) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundRate",
      "label": "Outbound Rate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.outboundRate) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageBaseFee",
      "label": "Storage Base Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.storageBaseFee) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageBaseFeeOver",
      "label": "Storage Base Fee > Years"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.hasSingleSeted ? 'green' : 'black'
          })
        }, [_vm._v("\n                            " + _vm._s(scope.row.storageBaseFeeOver) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showCustomEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), (scope.row.hasSingleSeted) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCustomItem(scope.row)
            }
          }
        }, [_vm._v("Restore")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customCategoryVisible = false;
        _vm.getAllUserRate()
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Custom Edit Category",
      "width": "80%",
      "visible": _vm.customEditVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customEditVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "customEditCategory",
    attrs: {
      "model": _vm.customEditCategory,
      "label-width": "220px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Short Label",
      "prop": "sizeLabel"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.customEditCategory.sizeLabel),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "sizeLabel", $$v)
      },
      expression: "customEditCategory.sizeLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Full Label",
      "prop": "sizeDefined"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.customEditCategory.sizeDefined),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "sizeDefined", $$v)
      },
      expression: "customEditCategory.sizeDefined"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Base Fee",
      "prop": "inboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.inboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "inboundBaseFee", $$v)
      },
      expression: "customEditCategory.inboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Inbound Rate",
      "prop": "inboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.inboundRate),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "inboundRate", $$v)
      },
      expression: "customEditCategory.inboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Base Fee",
      "prop": "outboundBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.outboundBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "outboundBaseFee", $$v)
      },
      expression: "customEditCategory.outboundBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Outbound Rate",
      "prop": "outboundRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.outboundRate),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "outboundRate", $$v)
      },
      expression: "customEditCategory.outboundRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee",
      "prop": "storageBaseFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.storageBaseFee),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "storageBaseFee", $$v)
      },
      expression: "customEditCategory.storageBaseFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Base Fee >Years",
      "prop": "storageBaseFeeOver"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 4,
      "step": 0.05,
      "min": 0.0000
    },
    model: {
      value: (_vm.customEditCategory.storageBaseFeeOver),
      callback: function($$v) {
        _vm.$set(_vm.customEditCategory, "storageBaseFeeOver", $$v)
      },
      expression: "customEditCategory.storageBaseFeeOver"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customEditVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.customEditLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.customEditSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6299182"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/warehouseAdmin/boxsizes.vue
// module id = 849
// module chunks = 1